import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaLayerGroup, FaIdCard, FaHistory } from 'react-icons/fa';
import { FaSheetPlastic } from "react-icons/fa6";
import { GiMoneyStack } from 'react-icons/gi';
import { RiUserLine } from 'react-icons/ri';
import './sidebar.css';
import logo from "../../logo.png"
const Sidebar = () => {
  const location = useLocation();
  console.log('Current Location:', location.pathname);
  return (
    <div className="sidebar-container h-full bg-black text-white block" >
      {/* Logo */}
      <div className="flex items-center justify-center py-4 mx-2">
        <img src={logo} alt="Logo" className="w-9" />
      </div>

      {/* Sidebar Menu */}
      <ul className="mt-8 sidebar-menu group">
        <li className={`group flex items-center mb-8 sidebar-item`}>
          <FaLayerGroup className="h-6 w-6 mr-3 icon ml-3" />
          <NavLink to="/dashboard/sections" exact activeClassName="active" className="flex items-center py-2 px-4 hover:text-white lg:mb-0 sidebar-title  opacity-50 ">
            <span>Sections</span>
          </NavLink>
        </li>
        <li className={`flex items-center mb-8 sidebar-item `}>
          <FaIdCard className="h-6 w-6 mr-3 icon ml-3" />
          <NavLink to="/dashboard/students"  activeClassName="active" className={`flex items-center py-2 px-4 hover:text-white lg:mb-0 sidebar-title sm:textsm`}>
            <span>Student Details</span>
          </NavLink>
        </li>
        <li className={`flex items-center mb-8 sidebar-item `}>
          <FaSheetPlastic className="h-6 w-6 mr-3 icon ml-3" />
          <NavLink to="/dashboard/attendance" exact activeClassName="active" className={`flex items-center py-2 px-4 hover:text-white lg:mb-0 sidebar-title`}>
            Attendance
          </NavLink>
        </li>
        <li className={`flex items-center mb-8 sidebar-item`} activeClassName='active border-r-4 border-white' >
          <GiMoneyStack className="h-6 w-6 mr-3 icon ml-3" />
          <NavLink to="/dashboard/fees" activeClassName="active hover-effect" className={` opacity-50 flex items-center py-2 px-4 hover:text-white lg:mb-0 sidebar-title`}>
            <span>Fees</span>
          </NavLink>
        </li>       
        <li className={`flex items-center mb-8 sidebar-item`} activeClassName='active border-r-4 border-white' >
          <FaHistory className="h-6 w-6 mr-3 icon ml-3" />
          <NavLink to="/dashboard/History" activeClassName="active hover-effect" className={` opacity-50 flex items-center py-2 px-4 hover:text-white lg:mb-0 sidebar-title`}>
            <span>History</span>
          </NavLink>
        </li>       
      </ul>
      <ul>
         {/* Language button */}
         <li className="flex flex-col items-center mt-40 lg:mt-52 mr-2 end-section">
          <button className="text-gray-400 py-2 hover:text-white">
            AR
          </button>
          <RiUserLine className="h-6 w-6 mt-2" />
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
